module.exports = __webpack_public_path__ + "static/media/phone_4.05a23b0c.png";